(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wh-new-colors-badge"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wh-new-colors-badge')) {
    class WhNewColorsBadge extends HTMLElement {
      constructor() {
        super();
        this.checkExpiry = this.checkExpiry.bind(this);
      }

      connectedCallback() {
        window.addEventListener('pageshow', this.checkExpiry);
        document.addEventListener('visibilitychange', this.checkExpiry);
        this.checkExpiry();
      }

      disconnectedCallback() {
        window.clearTimeout(this.expiryTimer);
        window.removeEventListener('pageshow', this.checkExpiry);
        document.removeEventListener('visibilitychange', this.checkExpiry);
      }

      checkExpiry() {
        window.clearTimeout(this.expiryTimer);

        const expiresAt = Number(this.getAttribute('data-expires'));
        const remaining = expiresAt * 1000 - Date.now();
        this.hidden = !Number.isSafeInteger(expiresAt) || expiresAt <= 0 || remaining <= 0;

        if (!this.hidden) {
          this.expiryTimer = window.setTimeout(this.checkExpiry, Math.min(remaining, 2147483647));
        }
      }
    }

    customElements.define('wh-new-colors-badge', WhNewColorsBadge);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wh-variant-new-controller"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wh-variant-new-colors')) {
    const berlinClock = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Berlin',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    });

    const endOfBerlinDate = (value) => {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return 0;
      const [year, month, day] = value.split('-').map(Number);
      if (year < 1000) return 0;
      const date = new Date(Date.UTC(year, month - 1, day));
      if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return 0;
      const wallMidnight = Date.UTC(year, month - 1, day + 1);
      let instant = wallMidnight;
      for (let pass = 0; pass < 3; pass += 1) {
        const parts = {};
        berlinClock.formatToParts(instant).forEach(({ type, value: part }) => {
          if (type !== 'literal') parts[type] = Number(part);
        });
        const wallTime = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
        instant += wallMidnight - wallTime;
      }
      return instant;
    };

    class WhVariantNewColors extends HTMLElement {
      connectedCallback() {
        this.picker = this.closest('variant-picker');
        if (!this.picker) return;
        this.selectedVariantId = this.dataset.selectedVariant || '';
        this.expiries = new Map();
        this.onVariantChange = (event) => {
          if (event.target !== this.picker) return;
          this.selectedVariantId = event.detail.variant ? String(event.detail.variant.id) : '';
          this.refresh();
        };
        this.onResume = () => this.refresh();
        this.picker.addEventListener('on:variant:change', this.onVariantChange);
        document.addEventListener('visibilitychange', this.onResume);
        window.addEventListener('pageshow', this.onResume);
        window.addEventListener('focus', this.onResume);
        this.frame = requestAnimationFrame(() => {
          if (!this.isConnected) return;
          this.querySelectorAll('[data-variant-id][data-until]').forEach((entry) => {
            this.expiries.set(entry.dataset.variantId, endOfBerlinDate(entry.dataset.until));
          });
          this.refresh();
        });
        customElements.whenDefined('variant-picker').then(() => {
          if (!this.isConnected || !this.picker.hasAttribute('loaded')) return;
          this.selectedVariantId = this.picker.variant ? String(this.picker.variant.id) : '';
          this.refresh();
        });
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        cancelAnimationFrame(this.frame);
        this.picker?.removeEventListener('on:variant:change', this.onVariantChange);
        document.removeEventListener('visibilitychange', this.onResume);
        window.removeEventListener('pageshow', this.onResume);
        window.removeEventListener('focus', this.onResume);
      }

      refresh() {
        clearTimeout(this.timer);
        if (!this.isConnected || !this.picker) return;
        const now = Date.now();
        this.picker.querySelectorAll('.wh-variant-new-badge').forEach((badge) => {
          badge.hidden = !(this.expiries.get(badge.dataset.variantId) > now);
        });
        const selectedIsNew = this.expiries.get(this.selectedVariantId) > now;
        this.picker.querySelectorAll('.wh-variant-new-selected').forEach((label) => {
          label.hidden = !selectedIsNew;
        });
        const future = [...this.expiries.values()].filter((expiry) => expiry > now);
        if (future.length) {
          this.timer = setTimeout(() => this.refresh(), Math.min(Math.min(...future) - now, 2147483647));
        }
      }
    }

    customElements.define('wh-variant-new-colors', WhVariantNewColors);
  }
  } catch(e) { console.error(e); }
})();

})();
